import { render, staticRenderFns } from "./CustomerDataDialog.vue?vue&type=template&id=00ff1d52&scoped=true"
import script from "./CustomerDataDialog.vue?vue&type=script&lang=js"
export * from "./CustomerDataDialog.vue?vue&type=script&lang=js"
import style0 from "./CustomerDataDialog.vue?vue&type=style&index=0&id=00ff1d52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ff1d52",
  null
  
)

export default component.exports